// extracted by mini-css-extract-plugin
export var layoutContainer = "_df-0";
export var layoutContainerNoRounding = "_df-6";
export var layoutContainerOpen = "_df-5";
export var layoutContainerResizing = "_df-1";
export var mainContent = "_df-2";
export var resizeDivider = "_df-3";
export var slidePanel = "_df-4";